import React, { FC } from "react";
import StyleProviders from "components/providers/StyleProviders";
import FirebaseSessionProvider from "components/providers/FirebaseSessionProvider";
import InternationalizationProvider from "components/providers/InternationalizationProvider";
import ErrorMessageProvider from "components/providers/ErrorMessageProvider";
import SuccessMessageProvider from "components/providers/SuccessMessageProvider";

const AppProviders:  React.FC = ({ children }) => (
  <InternationalizationProvider>
    <FirebaseSessionProvider>
      <StyleProviders>
        <ErrorMessageProvider>
          <SuccessMessageProvider>
            <>{children}</>
          </SuccessMessageProvider>
        </ErrorMessageProvider>
      </StyleProviders>
    </FirebaseSessionProvider>
  </InternationalizationProvider>
);

export default AppProviders;
